<template>
  <div :title="$t('eip.nav.operationManual')" @click="openHandbook">
    <i class="iconfont icon-bpm-record" />
  </div>
</template>

<script>
  export default {
    name: 'HtHandbook',
    methods: {
      openHandbook() {
        const lang = this.$i18n.locale

        const urls = {
          zh: 'https://transsioner.feishu.cn/wiki/HqRSw3AtMikUQQkpW5GcAPd3n7b', // 中文环境的 URL
          en: 'https://transsioner.feishu.cn/wiki/RKMHw6yQCiCIsfkOu8ucYlpgnmg', // 英文环境的 URL
        }
        const url = urls[lang]
        if (url) {
          window.open(url, '_blank')
        }
      },
    },
  }
</script>
